import { Input, Button, Form } from 'antd';
import { UserOutlined, KeyOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { getThunkDispatch } from 'myredux/store';
import { processLogin } from 'myredux/loginActions';
import { StoreState } from 'types';
import { changeAppModule } from 'myredux/globalSlice';
import { validateMessages } from 'utils/formUtils';

const Login = () => {
    const dispatch = getThunkDispatch();
    const [form] = Form.useForm();

    const { strictCashdesk } = useSelector((state: StoreState) => state.global);
    const { loading, error } = useSelector((state: StoreState) => state.login);

    const logIn = async (fieldsValue: any) => {
        dispatch(processLogin()({ email: fieldsValue.username, password: fieldsValue.password }));
    };

    return (
        <div className="LoginWrapper" onKeyDownCapture={(event) => (event.key === 'Enter' ? form.submit : null)}>
            <div className="LoginAuth">
                <p className="LoginTitle" onClick={() => dispatch(changeAppModule())}>
                    {strictCashdesk ? 'POKLADNATHOR' : 'REZERTVATHOR'}
                </p>
                <p className="LoginTitleModule">{strictCashdesk ? 'Pokladna' : 'Rezervace'}</p>

                <Form layout="vertical" scrollToFirstError form={form} onFinish={logIn} size="large" preserve validateMessages={validateMessages()}>
                    <Form.Item name="username" hasFeedback rules={[{ required: true, type: 'email' }]}>
                        <Input allowClear autoComplete="username" status={error && 'error'} prefix={<UserOutlined />} placeholder="Přihlašovací údaje" />
                    </Form.Item>

                    <Form.Item name="password" hasFeedback rules={[{ required: true }]}>
                        <Input.Password allowClear autoComplete="current-password" status={error && 'error'} placeholder="Heslo" prefix={<KeyOutlined />} />
                    </Form.Item>

                    <Form.Item label={null}>
                        <Button type="primary" htmlType="submit" block loading={loading}>
                            Přihlásit se
                        </Button>
                    </Form.Item>
                </Form>
            </div>
            <small>JVBros © 2025 | Version 4.4.1</small>
        </div>
    );
};

export default Login;
